import React from 'react';

import { Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { IButtonImageV3 } from '../../../../interfaces/button';
import { TRANSLATIONS_GLOBAL } from '../../../../translations/commons';
import { GenericFunction } from '../../../../types/genericTypes';
import BdsIconButton from '../../Buttons/BdsIconButton/BdsIconButton';
import ErrorCard from '../ErrorCard/ErrorCard';

import './DetailCard.scss';

export interface IDetailCard {
  title: string;
  description?: string;
  icon?: string;
  iconButton?: IButtonImageV3;
  type?: 'detail' | 'insight';
  action?: GenericFunction;
  retry?: GenericFunction;
  error?: boolean;
  loading?: boolean;
}

const DetailCard = ({
  title,
  description,
  icon,
  iconButton,
  type = 'detail',
  action,
  retry,
  error = false,
  loading = false
}: IDetailCard) => {
  const isInsight = type === 'insight';

  const { t } = useTranslation();

  if (loading) {
    return <Skeleton className="dc-skeleton" height={238} variant="rectangular" />;
  }

  if (error) {
    return (
      <div className={`dc-container flex flex-col gap-8 p-10 ${isInsight && 'insight'}`} data-experience="new">
        <ErrorCard
          primaryText={t(TRANSLATIONS_GLOBAL.errorCard.title)}
          secondaryText={t(TRANSLATIONS_GLOBAL.errorCard.description)}
          action={retry}
          buttonText={t(TRANSLATIONS_GLOBAL.errorCard.buttonText)}
        />
      </div>
    );
  }

  return (
    <div
      className={`dc-container flex flex-col justify-center gap-8 p-10 ${isInsight && 'insight'}`}
      data-experience="new"
    >
      <div className="flex flex-row justify-between" data-experience="new">
        <div className="flex flex-row gap-6 items-center">
          {icon && !isInsight && <img className="dc-icon" src={icon} alt="icon" />}
          <div className={`dc-title ${isInsight && 'insight'}`}>{title}</div>
        </div>
        <div className="dc-icon-button">
          {iconButton && action && <BdsIconButton icon={iconButton} action={action} variant="primary" size="lg" />}
        </div>
      </div>
      <div className="dc-description">{description}</div>
    </div>
  );
};

export default DetailCard;
